import { Component, inject, input, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';
import { TranslatePipe } from '@ngx-translate/core';

import { MediaService } from '@exl-ng/mulo-core';
import { CenteredBlockLayoutComponent } from '@exl-ng/mulo-views';

import SwiperCore, { Navigation, Pagination } from 'swiper';
import { SwiperModule } from 'swiper/angular';
import { AriaSwiperDirective } from '../../shared/directives/a11y/aria-swiper.directive';
import { MediaMention } from '../../shared/interfaces/media-mention.interface';
import { CitationBriefComponent } from '../../parts/citations/citation-brief/citation-brief.component';
import { ProfileMentionsService } from '../../profile/profile-mentions/profile-mentions.service';
import { ResearchUnitsService } from '../research-units.service';

SwiperCore.use([Navigation, Pagination]);

@Component({
    selector: 'esp-research-unit-media-mentions',
    imports: [
        CenteredBlockLayoutComponent,
        SwiperModule,
        AriaSwiperDirective,
        CitationBriefComponent,
        TranslatePipe,
    ],
    templateUrl: './research-unit-media-mentions.component.html',
    styleUrl: './research-unit-media-mentions.component.scss',
})
export class ResearchUnitMediaMentionsComponent {
    private mmSvc = inject(ProfileMentionsService);
    private unitsSvc = inject(ResearchUnitsService);
    media = inject(MediaService);

    mentions = toSignal(
        this.mmSvc
            .getMediaMentionsOfOrgUnit(this.unitsSvc.homepageOrgUnitCode())
            .pipe(map((pageData) => pageData.results)),
    );

    getByline(mention: MediaMention) {
        let byline: string;
        if (mention.source && mention.reporter) {
            byline = `${mention.source} (${mention.reporter})`;
        } else if (mention.source) {
            byline = mention.source;
        } else if (mention.reporter) {
            byline = mention.reporter;
        }
        return byline;
    }
}
